import React from "react";
import { Images, Video } from "lucide-react";
import { cn } from "../../lib/utils";

type JobListMediaCountsProps = {
  photoCount: number;
  videoCount: number;
  className?: string;
};

export const JobListMediaCounts: React.FC<JobListMediaCountsProps> = ({
  photoCount,
  videoCount,
  className,
}) => {
  if (photoCount === 0 && videoCount === 0) {
    return (
      <span className={cn("text-sm text-muted-foreground", className)}>—</span>
    );
  }

  return (
    <div
      className={cn(
        "flex items-center gap-2.5 text-muted-foreground",
        className,
      )}
    >
      {photoCount > 0 ? (
        <span
          className="inline-flex items-center gap-1 text-xs font-medium"
          aria-label={`${photoCount} photo${photoCount === 1 ? "" : "s"}`}
        >
          <Images className="h-3.5 w-3.5 shrink-0" aria-hidden />
          <span className="tabular-nums text-foreground">{photoCount}</span>
        </span>
      ) : null}
      {videoCount > 0 ? (
        <span
          className="inline-flex items-center gap-1 text-xs font-medium"
          aria-label={`${videoCount} video${videoCount === 1 ? "" : "s"}`}
        >
          <Video className="h-3.5 w-3.5 shrink-0" aria-hidden />
          <span className="tabular-nums text-foreground">{videoCount}</span>
        </span>
      ) : null}
    </div>
  );
};
